.right {
  display: flex;
  gap: 20px;
  align-items: center;
}
